"use strict";

import { Screen } from "../../systems/core/screen.js";

export class UIObjectCreator {
    static createParenting(object,config) {
        if (config.parent === undefined) return;
        
        object.parentContainer = config.parent;
        object.parentContainer.addChild(object);

        if (config.zIndex === undefined) return;
        
        object.zIndex = config.zIndex;
    }

    static createRect(object,config) {
        object.rect = {
            position: { x: 0, y: 0 },
            marginX: { left: 0, right: 0 },
            marginY: { top: 0, bottom: 0 },
            size: { width: object.width, height: object.height },
            anchorX: { min: 0.5, max: 0.5 },
            anchorY: { min: 0.5, max: 0.5 },
            pivot: { x: 0.5, y: 0.5 },
            scale: { x: 1, y: 1 }
        };
        object.calculatedRect = {
            center: { x: 0, y: 0 },
            bounds: { left: 0, bottom: 0, right: 0, top: 0 },
            size: { width: 0, height: 0 }
        };

        if (config.rect === undefined) return;
        
        if (config.rect.position !== undefined) {
            if (config.rect.position.x !== undefined && typeof config.rect.position.x === "number") {
                object.rect.position.x = config.rect.position.x;
            }
            if (config.rect.position.y !== undefined && typeof config.rect.position.y === "number") {
                object.rect.position.y = config.rect.position.y;
            }
        }

        if (config.rect.marginX !== undefined) {
            if (config.rect.marginX.left !== undefined && typeof config.rect.marginX.left === "number") {
                object.rect.marginX.left = config.rect.marginX.left;
            }
            if (config.rect.marginX.right !== undefined && typeof config.rect.marginX.right === "number") {
                object.rect.marginX.right = config.rect.marginX.right;
            }
        }
        
        if (config.rect.marginY !== undefined) {
            if (config.rect.marginY.top !== undefined && typeof config.rect.marginY.top === "number") {
                object.rect.marginY.top = config.rect.marginY.top;
            }
            if (config.rect.marginY.bottom !== undefined && typeof config.rect.marginY.bottom === "number") {
                object.rect.marginY.bottom = config.rect.marginY.bottom;
            }
        }
        
        if (config.rect.size !== undefined) {
            if (config.rect.size.width !== undefined && typeof config.rect.size.width === "number") {
                object.rect.size.width = config.rect.size.width;
            }
            if (config.rect.size.height !== undefined && typeof config.rect.size.height === "number") {
                object.rect.size.height = config.rect.size.height;
            }
        }

        if (config.rect.anchorX !== undefined) {
            if (typeof config.rect.anchorX === "number") {
                object.rect.anchorX.min = config.rect.anchorX;
                object.rect.anchorX.max = config.rect.anchorX;
            } else {
                if (config.rect.anchorX.min !== undefined && typeof config.rect.anchorX.min === "number") {
                    object.rect.anchorX.min = config.rect.anchorX.min;
                }
                if (config.rect.anchorX.max !== undefined && typeof config.rect.anchorX.max === "number") {
                    object.rect.anchorX.max = config.rect.anchorX.max;
                }
            }
        }

        if (config.rect.anchorY !== undefined) {
            if (typeof config.rect.anchorY === "number") {
                object.rect.anchorY.min = config.rect.anchorY;
                object.rect.anchorY.max = config.rect.anchorY;
            } else {
                if (config.rect.anchorY.min !== undefined && typeof config.rect.anchorY.min === "number") {
                    object.rect.anchorY.min = config.rect.anchorY.min;
                }
                if (config.rect.anchorY.max !== undefined && typeof config.rect.anchorY.max === "number") {
                    object.rect.anchorY.max = config.rect.anchorY.max;
                }
            }
        }

        if (config.rect.pivot !== undefined) {
            if (typeof config.rect.pivot === "number") {
                object.rect.pivot.x = config.rect.pivot;
                object.rect.pivot.y = config.rect.pivot;
            } else {
                if (config.rect.pivot.x !== undefined && typeof config.rect.pivot.x === "number") {
                    object.rect.pivot.x = config.rect.pivot.x;
                }
                if (config.rect.pivot.y !== undefined && typeof config.rect.pivot.y === "number") {
                    object.rect.pivot.y = config.rect.pivot.y;
                }
            }
        }

        if (config.rect.scale !== undefined) {
            if (typeof config.rect.scale === "number") {
                object.rect.scale.x = config.rect.scale;
                object.rect.scale.y = config.rect.scale;
            } else {
                if (config.rect.scale.x !== undefined && typeof config.rect.scale.x === "number") {
                    object.rect.scale.x = config.rect.scale.x;
                }
                if (config.rect.scale.y !== undefined && typeof config.rect.scale.y === "number") {
                    object.rect.scale.y = config.rect.scale.y;
                }
            }
        }
    }

    static setAspectRatioBehaviour(object,config) {
        object.preserveAspectRatio = {
            mode: "none",
            ratio: 1
        };

        if (config.preserveAspectRatio === undefined) return;
        if (typeof config.preserveAspectRatio !== "object") return;
        if (config.preserveAspectRatio.mode === undefined) return;
        if (typeof config.preserveAspectRatio.mode !== "string") return;

        if (config.preserveAspectRatio.mode !== "widthControlsHeight" &&
            config.preserveAspectRatio.mode !== "heightControlsWidth" &&
            config.preserveAspectRatio.mode !== "fitInParent" &&
            config.preserveAspectRatio.mode !== "envelopParent") return;

        object.preserveAspectRatio.mode = config.preserveAspectRatio.mode;

        if (config.preserveAspectRatio.ratio === undefined ||
            typeof config.preserveAspectRatio.ratio !== "number") {
            object.preserveAspectRatio.ratio = object._originalAspectRatio;
        } else {
            object.preserveAspectRatio.ratio = config.preserveAspectRatio.ratio;
        }
    }
    static setTextAspectRatioBehaviour(object,config) {
        if (config.allowStretching !== undefined && typeof config.allowStretching === "boolean") {
            object.allowStretching = config.allowStretching;
        } else if (config.envelopAspectRatio !== undefined && typeof config.envelopAspectRatio === "boolean") {
            object.envelopAspectRatio = config.envelopAspectRatio;
        }
    }

    static setRotationAngle(object,config) {
        object.angle = config.angle ?? 0;
    }
    static setVisibility(object,config) {
        object.visible = config.visible ?? true;
    }
    static setRenderability(object,config) {
        object.renderable = config.renderable ?? true;
    }
    static setInteractibility(object,config) {
        object.interactive = config.interactive ?? false;
    }

    static setResolutionListeners(object,advanced,config) {
        object._onResolutionWillChangeCallback = config.onResolutionWillChange;
        object._onResolutionChangedCallback = config.onResolutionChanged;
        if (!advanced) return;
        object._onResolutionChangedAfterCallback = config.onResolutionChangedAfter;
    }
    static setOrientationListeners(object,advanced,config) {
        object._onOrientationChangedCallback = config.onOrientationChanged;
        if (!advanced) return;
        object._onOrientationWillChangeCallback = config.onOrientationWillChange;
    }

    static addGenericTransformations(object,config) {
        let parentUIScalingState = object.parentContainer?.ignoreUIScaling ?? false;
        object.ignoreUIScaling = config.ignoreUIScaling ?? parentUIScalingState;
        
        object.transformToUI = (value) => {
            if (typeof value === "object") {
                if (object.ignoreUIScaling) {
                    return {...value};
                }

                return {
                    x: value.x * Screen.UI.scaleFactor,
                    y: value.y * Screen.UI.scaleFactor
                };
            }

            return object.ignoreUIScaling ? value : 
                value * Screen.UI.scaleFactor;
        }
        object.transformFromUI = (value) => {
            if (typeof value === "object") {
                if (object.ignoreUIScaling) {
                    return {...value};
                }

                return {
                    x: value.x / Screen.UI.scaleFactor,
                    y: value.y / Screen.UI.scaleFactor
                };
            }

            return object.ignoreUIScaling ? value :
                value / Screen.UI.scaleFactor;
        }
    }
}